export default __webpack_public_path__ + "static/media/LOGO CABANG DINAS-06.2e5ccf74.png";